import {
  BibliographyTagRegisterData,
  BibliographyTagRegisterDataToJSON
} from '@/api/models'

import { SystemCode } from '@/api'

export interface BibliographyRealCreateRequest {
  searchType: SystemCode
  bibliographySetId?: number
  details: BibliographyTagRegisterData[]
}

export function BibliographyRealCreateRequestToJSON(
  value: BibliographyRealCreateRequest
): any {
  return {
    search_type: value.searchType.code,
    bibliography_set_id: value.bibliographySetId ?? undefined,
    details: value.details.map(BibliographyTagRegisterDataToJSON)
  }
}
